// reporting-logger.ts
// Reporting-specific logger with extended categories

import { LogCategory as BaseLogCategory, ExtendLogCategory, createLogger } from '@personicom/customizations';

/**
 * Extended log categories for the Reporting application
 */
export type ReportingLogCategory = ExtendLogCategory<'Reporting' | 'Grid' | 'Filter'>;

/**
 * Reporting-specific logger instance with extended categories
 * Use this instead of the base logger for reporting-specific logging
 */
export const reportingLogger = createLogger<ReportingLogCategory>();

// Re-export base categories for convenience
export type { LogCategory as BaseLogCategory } from '@personicom/customizations';
export { LogLevel } from '@personicom/customizations';
